import { FC } from 'react';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter';
import { InlineFilterGroup } from 'shared/components/InlineFilterGroup';
import { InlineFilterSection } from 'shared/components/InlineFilterSection';
import { DecorationsListContainer, RepairContainer } from './containers';

export const RenovationContainer: FC = () => {
  return (
    <AdvancedFilterRow label="Ремонт и отделка">
      <InlineFilterGroup>
        <InlineFilterSection title="На вторичке" dataTestId="repair">
          <RepairContainer />
        </InlineFilterSection>
      </InlineFilterGroup>
      <InlineFilterGroup>
        <InlineFilterSection title="В новостройках" dataTestId="decorationsList">
          <DecorationsListContainer />
        </InlineFilterSection>
      </InlineFilterGroup>
    </AdvancedFilterRow>
  );
};
